import React from 'react';
import NameField from '../../components/NameField';
import DescriptionField from '../../components/DescriptionField';
import AvailableToClientField from '../../components/AvailableToClient';
import PeriodField from '../../components/PeriodFields';
import styles from '../../index.module.scss';

const FormComponent = () => {
  return (
    <>
      <div className={styles.nameDescriptionWrapper}>
        <NameField />
        <DescriptionField />
        <AvailableToClientField />
      </div>
      <PeriodField />
    </>
  );
};

export default FormComponent;
